module.exports = __webpack_public_path__ + "static/media/avatars_all_1.db5c2a9c.png";